interface Props {
    className?: string;
}

export function DeleteIcon({ className }: Props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 25 24" fill="none">
            <path
                d="M8.9375 4.3125H8.75C8.85313 4.3125 8.9375 4.22812 8.9375 4.125V4.3125H16.0625V4.125C16.0625 4.22812 16.1469 4.3125 16.25 4.3125H16.0625V6H17.75V4.125C17.75 3.29766 17.0773 2.625 16.25 2.625H8.75C7.92266 2.625 7.25 3.29766 7.25 4.125V6H8.9375V4.3125ZM20.75 6H4.25C3.83516 6 3.5 6.33516 3.5 6.75V7.5C3.5 7.60313 3.58437 7.6875 3.6875 7.6875H5.10312L5.68203 19.9453C5.71953 20.7445 6.38047 21.375 7.17969 21.375H17.8203C18.6219 21.375 19.2805 20.7469 19.318 19.9453L19.8969 7.6875H21.3125C21.4156 7.6875 21.5 7.60313 21.5 7.5V6.75C21.5 6.33516 21.1648 6 20.75 6ZM17.6398 19.6875H7.36016L6.79297 7.6875H18.207L17.6398 19.6875Z"
                fill="currentColor"
            />
        </svg>
    );
}
